import React, { useEffect, useState } from "react";
import {Button, Modal} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import ModalControls from "../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../defaults/Forms";
import { certificationTypeDefault } from "../../../../defaults/Items";
import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import DeleteWarningModal from "../../common/DeleteWarningModal";
import ItemDetailsModalHeader from "../../common/ItemDetailsModalHeader";
import TextInput from "../../../elements/TextInput";
import TextArea from "../../../elements/TextArea";
import useCrud from "../../../../hooks/useCrud";
import { Table } from "../../../table/Table";

import { MDBDataTableV5 } from "mdbreact";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import NumberInput from "../../../elements/NumberInput";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import Toggler from "../../../elements/Toggler";

import "../../../../css/DictionaryForms.css";

const CertificationType = () => {

  const dataUrl ="/certification-types";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = certificationTypeDefault;
  const itemName = "typ certyfikatu";
  const itemNames = "typy certyfikatów";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Skrócona nazwa", accessor: "shortName", sortable: true, searchable: true},
    {label: "Opis", accessor: "description", sortable: true, searchable: true},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    let formHasErrors = false;

      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
        formHasErrors = true;
      }

      if (!currentItem.shortName) {
        let shortNameInput = document.getElementById("shortName");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
        formHasErrors = true;
      }

      if (currentItem.expirationReminder && currentItem.expirationReminderThreshold === 0) {
        let expirationReminderThresholdInput = document.getElementById("expirationReminderThreshold");
        expirationReminderThresholdInput.classList.add("form-input-invalid");
        expirationReminderThresholdInput.placeholder = `ten element jest wymagany`;
        formHasErrors = true;
      }



      if (formHasErrors) return;


    let response;
    const item = {
      id: currentItem.id,
      shortName: currentItem.shortName,
      name: currentItem.name,
      description: currentItem.description
    };
    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);
    } else {
      response && onSaveAndClose({state});
    }
  }

  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }

  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };

  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])

  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])

  useEffect(() => {
    const getData = async () => {
      const response = await getItems(dataUrl);
      if (response.status === 200) {
        setLoading(false);
        setItems(response.data);
      } else if (response.status === 401 || response.status === 403) {
        navigate('/login', {state: {from: location}, replace: true})
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowy Typ certyfikatu`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }

  const modalTitle = currentFormState.formAddingDataMode
    ? "Nowa pozycja: Typ certyfikatu"
    : `Edycja: ${currentItem.name || "Typ certyfikatu"}`;

  return (
    <div id="layoutSidenav_content" className="dictionary-page">
      <AppComponentCardHeader title="Pozycje słownika Typy certyfikatów" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <Modal
        show={currentFormState.showForm}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        className="dictionary-form-modal"
        dialogClassName="dictionary-form-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dictionary-form-intro">
            <div>
              <strong>{currentFormState.formAddingDataMode ? "Dodajesz nową pozycję słownika" : "Edytujesz istniejącą pozycję słownika"}</strong>
              <span>Uzupełnij pola poniżej. Pola oznaczone gwiazdką są wymagane.</span>
            </div>
            {!currentFormState.formAddingDataMode && (
              <Button size="sm" variant="outline-secondary" onClick={() => {
                setUpdateConflict(false);
                restoreFormData({state});
              }}>
                Przywróć wartości
              </Button>
            )}
          </div>

          <form id="add-certification-type-form" name="add-certification-type-form" className="dictionary-form-grid">
            <div className="dictionary-form-field">
              <label htmlFor="name"><span className="required">*</span> Nazwa</label>
              <TextInput propertyName="name" required={true} state={state}/>
            </div>
            <div className="dictionary-form-field dictionary-form-field-short">
              <label htmlFor="shortName"><span className="required">*</span> Skrót</label>
              <TextInput propertyName="shortName" maxlen="10" required={true} state={state}/>
            </div>
            <div className="dictionary-form-field dictionary-form-field-full">
              <label htmlFor="description">Opis</label>
              <TextArea propertyName="description" required={false} rows="4" state={state}/>
            </div>
            <div className="dictionary-form-option-card">
              <div>
                <strong>Przypomnienie o wygaśnięciu</strong>
                <small>Włącz, jeżeli system ma przypominać przed końcem ważności certyfikatu.</small>
              </div>
              <Toggler propertyName="expirationReminder" state={state}/>
            </div>
            <div className="dictionary-form-field">
              <label htmlFor="expirationReminderThreshold">Dni do przypomnienia</label>
              <NumberInput propertyName="expirationReminderThreshold" defaultValue="7" min="0" max="99" required="true" state={state}/>
              <small>Liczba dni przed końcem ważności, kiedy ma pojawić się przypomnienie.</small>
            </div>
          </form>

          {updateConflict && (
            <div className="dictionary-form-error">
              <FontAwesomeIcon icon={faInfoCircle}/>
              <span>Nie można zapisać tej pozycji, ponieważ istnieje już wpis o tej nazwie lub skrócie.</span>
            </div>
          )}
        </Modal.Body>
        <ModalControls onDelete={onDelete} onCloseDetails={onClose} onSubmit={onSaveItemClick} state={state}/>
      </Modal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );

}

export default CertificationType;
